<template>
  <div class="my-4">
    <span class="text--error">{{ lgLabel }}</span>
    <v-data-table
      :headers="headers"
      :items="items"
      dense
    >
      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="(head, index) in headers"
            :key="index"
          >
            <v-text-field
              v-if="head.isEditable"
              :rules="rules"
              :value="item[head.value]"
              @input="v => handleUpdate(item.id, head.value, v)"
              maxLength="1024"
              hide-details
              dense
            ></v-text-field>
            <span v-else>{{ item[head.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { slugify } from "@/utils/string"
import { max1024 } from "@/utils/validator"

export default {
  name: "TableField",
  props: {
    label: { type: String, default: "" },
    cols: { type: Array, required: true },
    lines: { type: Array, required: true },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    headers: {
      get() {
        const firsts = [{ text: "ID", value: "id", sortable: true, isEditable: false }]
        const others = this.cols.map(e => ({
          text: e,
          value: slugify(e),
          sortable: true,
          isEditable: true
        }))
        return [...firsts, ...others]
      }
    },
    items: {
      get() {
        return this.values.length > 0
          ? this.lines.map(e => this.values.find(v => v.id === slugify(e)))
          : this.defaultItems()
      }
    }
  },
  data() {
    return {
      rules: [max1024]
    }
  },
  methods: {
    defaultItems() {
      return this.lines.map(e => {
        const entries = this.cols.map(e => [e, ""])
        return { id: e, ...Object.fromEntries(entries) }
      })
    },
    handleUpdate(line, col, newValue) {
      const refItems = this.items
      const lineIdx = refItems.findIndex(e => e.id === line)
      refItems[lineIdx][col] = newValue
      this.$emit("input", refItems)
    }
  }
}
</script>
